module.exports = __webpack_public_path__ + "img/tool-recharge.ef250905.png";